<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <saa-s-child-page-container
    :loading="!loading"
    :use-return="true"
    @back="back"
  >
    <template #title>
      <div class="text-h3">
        {{ $t('AadenRecommendLicenseType') }}
      </div>
      <div class="text-body-2 text--secondary">
        {{ $t('AadenRecommendLicenseTypeHint') }}
      </div>
    </template>

    <div
      class="mt-8"
    >
      <product-card
        v-for="item in productList"
        :key="item.id"
        :checked="selectedProductCode.includes(item.metadata.code)"
        :desc="item.description"
        :name="item.name"
        :one-time="item.realPrice.type"
        :price="item.realPrice.unit_amount/100"
        :read-only="item.readOnly"
        @clickCard="toggle(item.metadata.code)"
      />
    </div>
    <template #actions>
      <next-step-button
        class="btnContentSelect"
        @next="next(true)"
      >
        <div class="d-block overflow-hidden">
          <div class="text-truncate">
            {{ $t('RecommendedLicenseType') }}
          </div>
        </div>
      </next-step-button>
      <v-btn
        class="mt-4"
        color="grey lighten-3 black--text"
        elevation="0"
        small
        @click="next(false)"
      >
        <v-icon left>
          mdi-dots-horizontal
        </v-icon>
        {{ $t('AadenViewModulesAndCreateOwn') }}
      </v-btn>
    </template>
  </saa-s-child-page-container>
</template>

<script>
import ProductCard from '@/views/SaaS/widget/ProductCard.vue'
import NextStepButton from '@/views/SaaS/widget/NextStepButton.vue'
import sortBy from 'lodash-es/sortBy'
import { loadProducts, ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import SaaSChildPageContainer from '@/views/SaaS/widget/SaaSChildPageContainer.vue'
import { addProduct, clearProduct, getCurrentSaaSOrderInfo, readOnlyCode } from '@/views/SaaS/SaaSGuide'

export default {
  name: 'SelectRecommendLicence',
  components: {
    SaaSChildPageContainer,
    NextStepButton,
    ProductCard
  },
  data: function () {
    return {
      loading: false,
      productList: [],
      selectedProductCode: []
    }
  },
  computed: {
    totalOneTimePrice () {
      return (this.realSelectedList.filter(x => x.realPrice.type === 'one_time')
        .map(it => it.realPrice.unit_amount)).reduce(
        (a, b) => {
          return a + b
        }, 0) / 100 ?? 0
    },
    totalSubPrice () {
      return (this.realSelectedList.filter(x => x.realPrice.type !== 'one_time')
        .map(it => it.realPrice.unit_amount)).reduce(
        (a, b) => {
          return a + b
        }, 0) / 100 ?? 0
    },
    realSelectedList () {
      return this.productList.filter(it => this.selectedProductCode.includes(it.metadata.code))
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    toggle (code) {
      if (readOnlyCode.includes(code)) {
        return
      }
      if (this.selectedProductCode.includes(code)) {
        this.selectedProductCode = this.selectedProductCode.filter(it => it !== code)
      } else {
        this.selectedProductCode.push(code)
      }
    },
    async reload () {
      this.loading = false
      const res = await getCurrentSaaSOrderInfo()
      const allProducts = await loadProducts()
      this.selectedProductCode = [ProductCodes.base, ProductCodes.openDevice].concat(
        getCurrentSaaSOrderInfo().selectedProductList.map(it => it.metadata.code))
      const shouldShowCode = [ProductCodes.base, ProductCodes.tse, ProductCodes.openDevice]
      this.selectedProductCode.push(ProductCodes.tse)
      if (res.isChain) {
        shouldShowCode.push(ProductCodes.multistore)
      }
      if (res.storeType === 1) {
        shouldShowCode.push(ProductCodes.queneNumber, ProductCodes.kitchenMonitor)
      } else if (res.storeType === 2) {
        console.log('not doing anythign')
      } else if (res.storeType === 3) {
        shouldShowCode.push(ProductCodes.restaurant)
        this.selectedProductCode.push(ProductCodes.restaurant)
      } else if (res.storeType === 4) {
        shouldShowCode.push(ProductCodes.takeawayWeb)
      } else if (res.storeType === 5) {
        shouldShowCode.push(ProductCodes.restaurant, ProductCodes.staffManagement, ProductCodes.sales, ProductCodes.cashbook)
        this.selectedProductCode.push(ProductCodes.restaurant)
      } else if (res.storeType === 6) {
        shouldShowCode.push(ProductCodes.restaurant, ProductCodes.kitchenMonitor, ProductCodes.hotpotSystem)
        this.selectedProductCode.push(ProductCodes.restaurant)
      } else if (res.storeType === 7) {
        shouldShowCode.push(ProductCodes.advanceSales)
        this.selectedProductCode.push(ProductCodes.advanceSales)
      } else if (res.storeType === 8) {
        shouldShowCode.push(ProductCodes.reservation, ProductCodes.inventory)
      }
      const sort = {
        openDevice: 1,
        restaurant: 3.5,
        isChain: 3.6,
        base: 2,
        tse: 3,
        inventory: 4,
        reservation: 5,
        takeawayWeb: 6,
        boss: 7
      }
      this.productList = allProducts.filter(it => shouldShowCode.includes(it.metadata.code)).map(it => {
        it.sort = sort[it.metadata.code] ?? 99
        return it
      })

      this.productList.forEach(it => {
        if ([ProductCodes.base, ProductCodes.openDevice].includes(it.metadata.code)) {
          it.readOnly = true
        }
      })

      this.productList = sortBy(this.productList, (x) => {
        return x.sort
      })
      this.loading = true
    },
    back () {
      this.$router.push({ name: 'choose-store-type' })
    },
    next (useRecommended = false) {
      if (useRecommended) {
        clearProduct()
        this.realSelectedList.forEach(it => {
          addProduct(it)
        })
        this.$router.push({ name: 'host' })
      } else {
        this.$router.push({ name: 'free-mod' })
      }
    }
  }
}
</script>
